<template>
  <Modal title="编辑角色" v-model="isShow" @on-cancel="handle">
    <div class="myModal">
        <Form ref="roleInfo"  :model='roleInfo' label-position="right" :label-width="100" :rules="ruleValidate" @submit.native.prevent>
            <form-item label="角色名称" prop="role_name" v-if="roleInfo.role_id==1">
              <Input placeholder="请输入" v-model="roleInfo.role_name" disabled></Input>
            </form-item>
          <form-item label="角色名称" prop="role_name" v-else>
            <Input placeholder="请输入" v-model="roleInfo.role_name"></Input>
          </form-item>
          <form-item label="权限" prop="roles">
            <Tree :data="data2" show-checkbox ref="tree"></Tree>
          </form-item>
        </Form>
    </div>
    <div slot="footer">
        <Button type="primary"   @click="handleOk('roleInfo')">确定</Button>
    </div>
  </Modal>
</template>
<style scoped>
  .myModal {
    margin-left: 20px;
    margin-top: 20px;
  }
</style>
<script>
import { authAll, addRole, roleInfo } from '@/api/adminRole'
export default {
  name: 'roleEdit',
  props: ['editShow', 'id'],
  data () {
    return {
      isShow: false,
      role_id: 0,
      roleInfo: {
        role_id: 0,
        role_name: '',
        treeRole: []
      },
      data2: [],
      rules: '',
      ruleValidate: {
        role_name: [
          { required: true, message: '请输入角色名称', trigger: 'blur' }
        ]
      }
    }
  },
  watch: {
    editShow (val) {
      this.isShow = val
      this.roleInfo.role_id = 0
      this.roleInfo.role_name = ''
      this.roleInfo.treeRole = []
      this.getAuthList()
    },
    id (val) {
      this.role_id = val
      if (this.role_id > 0) {
        this.roleInfos()
      }
    }
  },
  created () {
    this.getAuthList()
  },
  methods: {
    handle (status) {
      this.$emit('updateStatusModel', false)
    },
    handleOk (name) {
      this.$refs[name].validate((valid) => {
        if (valid) {
          this.$refs.tree.getCheckedAndIndeterminateNodes().map((node) => {
            this.roleInfo.treeRole.push(node.menu_id)
          })
          if (this.roleInfo.treeRole.length === 0) return this.$Message.warning('请至少选择一个权限')
          addRole(this.roleInfo).then(async res => {
            let msg = '添加成功'
            if (this.roleInfo.role_id > 0) {
              msg = '编辑成功'
            }
            if (res.code === 200) {
              this.$Message.success(msg)
              this.$emit('updateStatusModel', false)
            } else {
              this.$Message.error(res.msg)
            }
          }).catch(res => {
            this.$Message.error(res.msg)
          })
        } else {
          return false
        }
      })
    },
    roleInfos () {
      if (this.role_id) {
        roleInfo(this.role_id).then(res => {
          let datas = res.data
          this.roleInfo = datas.list
          this.rules = this.roleInfo.roles
          this.tidyRes(datas.menu)
        }).catch(res => {
          this.$Message.error(res.msg)
        })
      }
    },
    getAuthList () {
      authAll().then(res => {
        this.data2 = res.data
      }).catch(res => {
        this.$Message.error(res.msg)
      })
    },
    tidyRes (menus) {
      let data = []
      menus.map((menu) => {
        data.push(this.initMenu(menu))
      })
      this.data2 = data
    },
    initMenu (menu) {
      // eslint-disable-next-line one-var
      let data = {}, checkMenus = ',' + this.rules + ','
      data.title = menu.title
      data.menu_id = menu.menu_id
      if (menu.children && menu.children.length > 0) {
        data.children = []
        menu.children.map((child) => {
          data.children.push(this.initMenu(child))
        })
      } else {
        // console.log(checkMenus)
        data.checked = checkMenus.indexOf(String(',' + data.menu_id + ',')) !== -1
        // data.expand = !data.checked
      }
      return data
    }
  }
}
</script>
